<template>
  <v-app>
    <v-app-bar flat elevate-on-scroll color="#793980" app hide-on-scroll>
      <v-toolbar-title>
        <a href="/" target="_self">
          <img src="assets/images/logo.png" />
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon class href="https://www.instagram.com/instacash.ar/" target="_blank">
        <v-icon class="color-a">mdi-magnify</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <transition
        name="router-anim"
        mode="out-in"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <router-view></router-view>
      </transition>
    </v-content>
    <v-footer dark class="p-0 mt-5" color="#793980">
      <footerIC/>
    </v-footer>
  </v-app>
</template>

<script>
import footerIC from "./components/footerIC";

export default {
  name: "App",
  components:{footerIC},

  data: () => ({
    //
  })
};
</script>
